export default __webpack_public_path__ + "media/images/messaging-90192e8da869ab6691a4fb3bbbc05758.svg";